import { render, staticRenderFns } from "./PriceWithTax.vue?vue&type=template&id=6a165c62&scoped=true&"
import script from "./PriceWithTax.vue?vue&type=script&lang=js&"
export * from "./PriceWithTax.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a165c62",
  null
  
)

export default component.exports